import { render, staticRenderFns } from "./SubscribedToCategory.vue?vue&type=template&id=cda98084&scoped=true"
import script from "./SubscribedToCategory.vue?vue&type=script&lang=js"
export * from "./SubscribedToCategory.vue?vue&type=script&lang=js"
import style0 from "./SubscribedToCategory.vue?vue&type=style&index=0&id=cda98084&prod&lang=scss&scoped=true"
import style1 from "./SubscribedToCategory.vue?vue&type=style&index=1&id=cda98084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda98084",
  null
  
)

export default component.exports